module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData && _vm.formData.title ? _vm.formData.title : 'register/title')))]), _vm._v(" "), (_vm.errorWithLogout) ? [_c('div', {
    staticClass: "text-center alert alert-danger",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.errorWithLogout),
      expression: "errorWithLogout"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logOut($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/logout')))])] : _vm._e(), _vm._v(" "), (!_vm.errorWithLogout) ? [(_vm.form_ErrorMessage) ? _c('div', [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "padding": "10px",
      "margin": "20px 0 20px"
    },
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.softReloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.successMessage) ? _c('form', {
    staticClass: "w5-from",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "w5-form-row"
    }, [(row && row.length) ? [_vm._l((row), function(field) {
      return [(['locale', 'code'].indexOf(field._field_name) < 0) ? _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _vm._e()]
    })] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.form_Loading) ? _c('img', {
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }) : _c('button', {
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.registration
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('page/user_register')))])])], 2)]) : _c('div', {
    style: (_vm.form_ErrorMessage || _vm.successMessage ? 'height: 0' : 'height: 135px')
  }), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "text-center alert alert-success",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.successMessage),
      expression: "successMessage"
    }],
    staticStyle: {
      "margin": "0",
      "padding": "10px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.formData && !_vm.form_Loading && !_vm.form_ErrorMessage) ? _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [(!_vm.successMessage) ? [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('login/already_registered')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])] : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.form_Loading),
      expression: "!form_Loading"
    }],
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.successToPanel
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])], 2) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d4b4e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Registration.vue
// module id = 447
// module chunks = 0